import { ApolloLink } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import Model from './index';

export const parseShape = (shape) => {
    if (!shape) {
        return shape
    }
    if (shape['edges']) {
        return parseShape(shape['edges']);
    } else if (shape['node']) {
        return parseShape(shape['node']);
    } else if (Array.isArray(shape)) {
        return shape.map((item) => parseShape(item));
    } else if (typeof(shape) === 'object' && !Array.isArray(shape)) {
        let result = {};
        for (let attr in shape) {
            result[attr] = parseShape(shape[attr]);
        }
        return result
    } else {
        return shape;
    }
};

export const wrapPromise = (promise) => {
    let status = 'pending'
    let response

    const suspender = promise.then(
        (res) => {
            status = 'success'
            response = res
        },
        (err) => {
            status = 'error'
            response = err
        },
    );
    const read = () => {
        switch (status) {
            case 'pending':
                throw suspender
            case 'error':
                throw response
            default:
                return response
        }
    }

    return { read }
}

export const proceedToCheckout = (proceed = () => {}) => {
    const { isAuthenticated } = Model.user;
    const { openKZLoginForm } = Model.modal;
    if (!window.isRuDomain && !isAuthenticated) {
        openKZLoginForm(proceed)
    } else {
        proceed();
    }
}
